import { fmt, fmtMoney, fmtDate, logoUrl, PayBadge } from "@/lib/api";
import { useSettings } from "@/hooks/useSettings";

export const Receipt = ({ sale }) => {
  const { logoV, settings } = useSettings();
  return (
  <div id="receipt" className="mx-auto w-full max-w-[300px] bg-white p-4 font-mono text-[12px] leading-tight text-black" data-testid="receipt">
    <div className="text-center">
      {logoV && <img src={logoUrl(logoV)} alt="logo" className="mx-auto mb-1 max-h-16 object-contain" data-testid="receipt-logo" />}
      <p className="text-base font-bold uppercase">{settings.company_name}</p>{settings.address && <p>{settings.address}</p>}
      <p>{sale.warehouse_name}</p>
      {settings.phone && <p>Tél : {settings.phone}</p>}{settings.extra_info && <p>{settings.extra_info}</p>}
      <p className="my-1">--------------------------------</p>
      <p className="font-bold">TICKET {sale.number}</p>
      <p>{fmtDate(sale.created_at)}</p>
      <p>Vendeur : {sale.seller_name}</p>
      {sale.customer_name && <p>Client : {sale.customer_name} {sale.customer_phone}</p>}
      <p className="my-1">--------------------------------</p>
    </div>
    {sale.lines.map((l, i) => (
      <div key={i} className="mb-1">
        <p className="font-semibold">{l.reference ? <span className="mr-1 text-[10px]">{l.reference}</span> : null}{l.fabric_name}</p>
        <div className="flex justify-between"><span>{fmt(l.sold_qty ?? l.quantity)} {l.sale_unit === "rouleau" ? `pc (${fmt(l.quantity)} m)` : (l.unit === "rouleau" ? "pc" : l.unit)}{l.pieces && l.sale_unit !== "rouleau" && l.unit !== "rouleau" ? ` · ${fmt(l.pieces)} pc` : ""} x {fmtMoney(l.unit_price)}</span><span>{fmtMoney(l.total)}</span></div>
      </div>
    ))}
    <p className="my-1 text-center">--------------------------------</p>
    <div className="flex justify-between"><span>Sous-total</span><span>{fmtMoney(sale.subtotal)}</span></div>
    {sale.discount > 0 && <div className="flex justify-between"><span>Remise</span><span>-{fmtMoney(sale.discount)}</span></div>}
    <div className="flex justify-between text-base font-bold"><span>TOTAL</span><span>{fmtMoney(sale.total)} {settings.currency}</span></div>
    {sale.due > 0 && <><div className="flex justify-between"><span>Payé</span><span>{fmtMoney(sale.paid_amount)}</span></div><div className="flex justify-between font-bold"><span>RESTE DÛ</span><span data-testid="receipt-due">{fmtMoney(sale.due)} {settings.currency}</span></div></>}
    <div className="flex justify-between"><span>Paiement</span><PayBadge method={sale.payment_method} /></div>
    {sale.modifications?.length > 0 && <div className="mt-1 border-t border-dashed pt-1 text-[10px]" data-testid="receipt-modifications">
      <p className="font-semibold">Modifié</p>
      {sale.modifications.map((m, i) => <p key={i}>{fmtDate(m.at)} · {m.by} · {fmtMoney(m.old_total)} → {fmtMoney(m.new_total)}</p>)}
    </div>}
    <p className="my-1 text-center">--------------------------------</p>
    <p className="text-center">{settings.receipt_message}</p>
    <p className="mt-2 text-center text-[10px]">{settings.footer}</p>
  </div>
);
};
